var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.103 9.68596L14.689 8.27196L5.375 17.586V19H6.789L16.103 9.68596ZM17.517 8.27196L18.931 6.85796L17.517 5.44396L16.103 6.85796L17.517 8.27196ZM7.617 21H3.375V16.757L16.81 3.32196C16.9975 3.13449 17.2518 3.02917 17.517 3.02917C17.7822 3.02917 18.0365 3.13449 18.224 3.32196L21.053 6.15096C21.2405 6.33849 21.3458 6.5928 21.3458 6.85796C21.3458 7.12313 21.2405 7.37743 21.053 7.56496L7.618 21H7.617Z",
    fill: "#344767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8c54d465ffe79c19fd6396b20e099ab1.svg";
export { ForwardRef as ReactComponent };